module.exports = __webpack_public_path__ + "static/media/photo275.96a12a3d.jpg";